/**
 * Tracks how many Ask AI questions the signed-in user has left this week.
 *
 * The backend allows 7 questions per week (resets Monday). It only counts
 * SUCCESSFUL answers, so we refresh this from the server after each answer
 * finishes rather than guessing locally.
 */

import { useState, useCallback, useEffect } from "react";
import { getSessionToken } from "../lib/clerk";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

export function useAiQuota() {
  const [quota, setQuota] = useState(null); // { used, limit, remaining, resets_at }
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const token = await getSessionToken();
      if (!token) {
        setLoading(false);
        return;
      }
      const res = await fetch(`${API_URL}/ai/quota`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setQuota(await res.json());
      }
    } catch {
      // Network hiccup — leave the last known value in place.
    } finally {
      setLoading(false);
    }
  }, []);

  // Load once when the Ask AI screen mounts.
  useEffect(() => {
    refresh();
  }, [refresh]);

  return { quota, loading, refresh };
}
